module.exports = __webpack_public_path__ + "img/Migrate data the easy way.bc6c50b4.gif";